import React from 'react'
import bgImage from '../../assets/img/contactme-background.jpg'



function Hero() {
  return (
    <div className='w-full mx-auto'>
        <div className='max-h-[630px] min-h-[280px] relative'>
        {/* Overlay */}
        <div className='absolute w-full h-full text-[#EEEEEE] max-h-[630px] min-h-[280px] bg-[#040404]/85  flex flex-col justify-center duration-300 '>
            <h1 className='px-4 text-4xl font-bold sm:text-5xl md:text-6xl lg:text-7xl capitalize'>Lets work together</h1>
            <h1 className='relative px-4 md:ml-[46px] text-4xl font-bold bottom-1 md:bottom-1 sm:text-5xl md:text-6xl lg:text-7xl capitalize'>bring your vision to life!</h1>
            <p className=' text-[15px] lg:text-[17px] xl:text-[19px]  text-[#aeaeae]  px-[30px] relative md:bottom-0 '>Get connected with me, work together, and know how to reach out for projects.</p>
        </div>
        <img className='w-full max-h-[630px] min-h-[280px] object-cover' src={bgImage} alt="" />
        </div>
    </div>
  )
}

export default Hero